import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, Renderer2} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormControl, FormGroup, FormBuilder} from '@angular/forms';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { ProjectEditingComponent } from 'src/app/back-office/components/edit-project/project-editing/project-editing.component';
import config from 'config/default.json';
import { MarkdownEditorComponent } from 'src/app/back-office/components/markdown-editor/markdown-editor.component';

@Component({
  selector: 'app-vcl-detail-content',
  templateUrl: './vcl-detail-content.component.html',
  styleUrls: ['./vcl-detail-content.component.scss']
})
export class VcDetailContentComponent{
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiServiceModule,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private helper: HelperModule,
    public dialog: MatDialog
    ) {}
    config = config;
  @Input() rowInfos: { [x:string]: any } = new Map();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() projectInfos: { [x:string]: any } = new Map();
  platformInfos:{[x: string]: any} = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'};
  

  @Output() inProgress = new EventEmitter<any>();
  @Output() updateStates = new EventEmitter<any>();
  @Output() updateContent = new EventEmitter<any>();

  countryControl = new FormControl();
  cycleControl = new FormControl();
  regionControl = new FormControl();
  institutionControl = new FormControl();
  studyControl = new FormControl();
  classControl = new FormControl();
  moduleControl = new FormControl();
  yearControl = new FormControl();
  periodControl = new FormControl();
  sectionControl = new FormControl();
  chapterControl = new FormControl();
  learningControl = new FormControl();
  typeControl = new FormControl();
  subjectControl = new FormControl();
  nameControl = new FormControl();
  linkControl = new FormControl();
  containsAnswerControl = new FormControl();
  rawValidControl = new FormControl();

  searchCountryControl = new FormControl();
  searchCycleControl = new FormControl();
  searchRegionControl = new FormControl();
  searchInstitutionControl = new FormControl();
  searchStudyControl = new FormControl();
  searchClassControl = new FormControl();
  searchModuleControl = new FormControl();
  searchYearControl = new FormControl();
  searchPeriodControl = new FormControl();
  searchSectionControl = new FormControl();
  searchChapterControl = new FormControl();
  searchLearningControl = new FormControl();
  searchTypeControl = new FormControl();
  searchSubjectControl = new FormControl();

  filteredCountries: { [x:string]: string|number|boolean }[] = [];
  filteredCycles: { [x:string]: string|number|boolean }[] = [];
  filteredRegions: { [x:string]: string|number|boolean }[] = [];
  filteredInstitutions: { [x:string]: string|number|boolean }[] = [];
  filteredStudies: { [x:string]: string|number|boolean }[] = [];
  filteredClasses: { [x:string]: string|number|boolean }[] = [];
  filteredModules: { [x:string]: string|number|boolean }[] = [];
  filteredYears: { [x:string]: string|number|boolean }[] = [];
  filteredPeriods: { [x:string]: string|number|boolean }[] = [];
  filteredSections: { [x:string]: string|number|boolean }[] = [];
  filteredChapters: { [x:string]: string|number|boolean }[] = [];
  filteredLearnings: { [x:string]: string|number|boolean }[] = [];
  filteredTypes: { [x:string]: string|number|boolean }[] = [];
  filteredSubjects: { [x:string]: string|number|boolean }[] = [];


  countries: { [x:string]: string|number|boolean }[] = [];
  cycles: { [x:string]: string|number|boolean }[] = [];
  regions: { [x:string]: string|number|boolean }[] = [];
  institutions: { [x:string]: string|number|boolean }[] = [];
  studies: { [x:string]: string|number|boolean }[] = [];
  classes: { [x:string]: string|number|boolean }[] = [];
  modules: { [x:string]: string|number|boolean }[] = [];
  years: { [x:string]: string|number|boolean }[] = [];
  periods: { [x:string]: string|number|boolean }[] = [];
  sections: { [x:string]: string|number|boolean }[] = [];
  types: { [x:string]: string|number|boolean }[] = [];
  subjects: { [x:string]: string|number|boolean }[] = [];
  chapters: { [x:string]: string|number|boolean }[] = [];
  learnings: { [x:string]: string|number|boolean }[] = [];

  showContentChapter:boolean = false;
  showContentLearning:boolean = false;
  showContentSubject:boolean = false;

  pdfRawData!:{ [x:string]: any };
  pdfEditData!:{ [x:string]: any };

  zoomOut:boolean = false;
  zoomIn:boolean = false;


  pdfMode:string = 'edit';

  rowId: number = 0;
  hasEdit: boolean = true;
  source: string = 'content';
  isRawClassify = false;

  ngOnInit(){
    this.isRawClassify = this.rowInfos['source'] == 'project' && this.projectInfos['state'] == 'splitting';
    this.pdfMode = this.isRawClassify ? 'raw': this.pdfMode;
    this.source = this.rowInfos['source'];
    this.rowId = this.rowInfos['id_content'];
    this.cdRef.detectChanges();
    this.loadOneInfos();
    if(['project', 'other_project'].includes(this.source)){
      this.hasEdit = this.rowInfos['edit_file_pdf']? true : false;
      this.pdfMode = !this.hasEdit? 'raw': this.pdfMode;
      this.pdfRawData = {contents: [{id_content: this.rowInfos['id_content'], url: this.config.master.ndapi.url + '/VIRTUALCLASS/'+this.rowInfos['raw_file_path']}], source: 'master', height: 320};
      this.pdfEditData = {contents: [{id_content: this.rowInfos['id_content'], url: this.config.master.ndapi.url + '/VIRTUALCLASS/'+this.rowInfos['edit_file_pdf']}], source: 'master', height: 320};
    }else {
      this.pdfRawData =  {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCLASS/'+this.rowInfos['raw_file_path']}], source: 'service', height: 320};
      this.pdfEditData = {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCLASS/'+this.rowInfos['edit_file_pdf']}], source: 'service', height: 320};
    };

    this.applySearch();
    
      
  }
  applySearch(){
    this.searchCountryControl.valueChanges.subscribe((text) => {
      return this.filteredCountries = this.countries.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchCycleControl.valueChanges.subscribe((text) => {
      return this.filteredCycles = this.cycles.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchRegionControl.valueChanges.subscribe((text) => {
      return this.filteredRegions = this.regions.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchInstitutionControl.valueChanges.subscribe((text) => {
      return this.filteredInstitutions = this.institutions.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchStudyControl.valueChanges.subscribe((text) => {
      return this.filteredStudies = this.studies.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchClassControl.valueChanges.subscribe((text) => {
      return this.filteredClasses = this.classes.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchModuleControl.valueChanges.subscribe((text) => {
      return this.filteredModules = this.modules.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchYearControl.valueChanges.subscribe((text) => {
      return this.filteredYears = this.years.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchPeriodControl.valueChanges.subscribe((text) => {
      return this.filteredPeriods = this.periods.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchSectionControl.valueChanges.subscribe((text) => {
      return this.filteredSections = this.sections.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchChapterControl.valueChanges.subscribe((text) => {
      return this.filteredChapters = this.chapters.filter(element => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchLearningControl.valueChanges.subscribe((text) => {
      return this.filteredLearnings = this.learnings.filter((element:any) => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchTypeControl.valueChanges.subscribe((text) => {
      return this.filteredTypes = this.types.filter(element => this.normalizeString(element['identifier']).includes(this.normalizeString(text)));
    });
    this.searchSubjectControl.valueChanges.subscribe((text) => {
      return this.filteredSubjects = this.subjects.filter((element:any) => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
  }
  selectedElement(selectedOptions: FormControl, element: { [x:string]: string|number|boolean }): boolean {
    return Array.isArray(selectedOptions.value) && selectedOptions.value.includes(element['id']);
  }
  normalizeString(str:any){
    return str.toString().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
  }
  applyUpdate(){
    let stateChecked = true;
    let moduleId = this.moduleControl.value;
    let yearId = this.yearControl.value;
    let sectionId = this.sectionControl.value;
    let chapterId = this.chapterControl.value;
    let learningId = this.learningControl.value;
    let typeId = this.typeControl.value;
    let subjectId = this.subjectControl.value;
    let nameContent = this.nameControl.value;
    let link = this.linkControl.value;

    nameContent = nameContent == '' || nameContent == null? null : nameContent;
    link = link == '' || link == null? null : link;

    if(sectionId == 4){//Course
      yearId = null;
      typeId = null;
      subjectId = null;
      learningId = null;
      if(nameContent == null || chapterId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Name / Chapter is not specified for this Course...');
      }
    }
    if([1, 2, 3, 8, 10].includes(sectionId)){//Annals
      chapterId = null;
      learningId = null;
      if(typeId == null || yearId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Year / Type is not specified...');
      }
    }
    if([5, 7].includes(sectionId)){//Exercise / Video
      yearId = null;
      chapterId = null;
      if(nameContent == null || typeId == null || learningId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Type / Name / Learning is not specified...');
      }
    }
    if(typeId != null && typeId == 2){//Type Corrected
      nameContent = null;
      if(subjectId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Linked Subject is not specified for this Answer...');
      }
    }

    if(moduleId != null){
      let content = {
        id_content:         this.rowId,
        id_country:         this.countryControl.value,
        id_cycle:           this.cycleControl.value,
        id_region:          this.regionControl.value || null,
        id_vcl_institution:     this.institutionControl.value || null,
        id_study:           this.studyControl.value,
        id_class:           this.classControl.value,
        id_module:          moduleId,
        id_year:            yearId,
        id_period:          this.periodControl.value,
        id_section:         sectionId,
        id_type:            typeId,
        id_content_subject: typeId == 2? subjectId: null,
        id_content_learning: learningId,
        content_name:       nameContent,
        content_url:        link,
        contain_answer:     this.containsAnswerControl.value,
        raw_valid:          this.rawValidControl.value
      }
      let data = {
        source: this.source,
        state: 'classified',
        state_checked: stateChecked,
        user_infos: this.userInfos,
        row_infos: this.rowInfos,
        content: content
      }
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/web/content/update_content_classification', data, this.userInfos['access_token']).subscribe((response:any)=>{
        this.updateContent.emit(response.contents);
        if(stateChecked) this.helper.showToast(response.message);
      });
    }else this.helper.showToast('Module is not defined...');

    
  }
  updateState(state:string, isChecked:boolean){
    this.inProgress.emit(true);
    let data = {
      source: this.source,
      state: state,
      state_checked: isChecked,
      row_infos: this.rowInfos,
      user_infos: this.userInfos,
      platform_infos: this.platformInfos
    }
    if(this.rowInfos['active'] && this.source == 'content'){
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '50%',
        position: {top: '30px' },
        data: {page: 'confirmation', text: 'This change will affect Students subscriptions. Continue ?'}
      });
      dialogRef.afterClosed().subscribe((toContinue:boolean) => {
        if(toContinue) this.applyUpdateState(config.master.ndapi.url + '/virtualclass/web/content/update_content_state', data);
      });
    }else this.applyUpdateState(config.master.ndapi.url + '/virtualclass/web/content/update_content_state', data);
  }
  applyUpdateState(url:string, formData:any){
    this.apiService.queryData(url, formData, this.userInfos['access_token']).subscribe((response:any)=>{
      if(response.status){
        this.updateStates.emit([{state: response.state, active: response.active, id_content: this.rowId}])
      }
      this.helper.showToast(response.message);
      this.inProgress.emit(false);
    })
  }
  loadOneInfos(){
    let data = {
      id_content: this.rowInfos['id_content'],
      id_project: this.source == 'project'? this.rowInfos['id_project']: null,
      content: this.rowInfos,
      source: this.source
    }; 
    this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/one_module_content_parents', data, this.userInfos['access_token']).subscribe((data:any)=>{
      this.countries = data.country;
      this.cycles = data.cycle;
      this.regions = data.region;
      this.institutions = data.institution;
      this.studies = data.study;
      this.classes = data.class;
      this.modules = data.module;
      this.years = data.year;
      this.periods = data.period;
      this.sections = data.section;
      this.chapters = data.chapter;
      this.learnings = data.learning;
      this.types = data.type;
      this.subjects = data.subject;

      this.filteredCountries = this.countries;
      this.filteredCycles = this.cycles;
      this.filteredRegions = this.regions;
      this.filteredInstitutions = this.institutions;
      this.filteredStudies = this.studies;
      this.filteredClasses = this.classes;
      this.filteredModules = this.modules;
      this.filteredYears = this.years;
      this.filteredPeriods = this.periods;
      this.filteredSections = this.sections;
      this.filteredChapters = this.chapters;
      this.filteredLearnings = this.learnings;
      this.filteredTypes = this.types;
      this.filteredSubjects = this.subjects;

      this.countryControl.setValue(this.rowInfos['id_country']);
      this.cycleControl.setValue(this.rowInfos['id_cycle']);
      this.regionControl.setValue(this.rowInfos['id_region'] || 0);
      this.institutionControl.setValue(this.rowInfos['id_vcl_institution'] || 0);
      this.studyControl.setValue(this.rowInfos['id_study']);
      this.classControl.setValue( this.rowInfos['id_class']);
      this.moduleControl.setValue(this.rowInfos['id_module']);
      this.yearControl.setValue(this.rowInfos['id_year']);
      this.periodControl.setValue(this.rowInfos['id_period']);
      this.sectionControl.setValue(this.rowInfos['id_section']);
      this.chapterControl.setValue(this.rowInfos['id_chapter']);
      if([5, 7].includes(this.rowInfos['id_section'])) this.learningControl.setValue(this.rowInfos['id_content_learning']);

      this.typeControl.setValue(this.rowInfos['id_type']);
      if(this.rowInfos['id_type'] == 2) this.subjectControl.setValue(this.rowInfos['id_content_subject']);
      this.nameControl.setValue(this.rowInfos['content_name']);
      this.linkControl.setValue(this.rowInfos['content_url']);
      this.containsAnswerControl.setValue(this.rowInfos['contain_answer']);
      this.rawValidControl.setValue(this.rowInfos['raw_valid']);

      this.showContentChapter = this.rowInfos['id_section'] == 4? true: false;
      this.showContentLearning = [5, 7].includes(this.rowInfos['id_section']) && this.rowInfos['id_type'] != 2? true: false;
      this.showContentSubject = this.rowInfos['id_type'] == 2? true: false;
      this.cdRef.detectChanges();
    })
  }
  updateRegion(){
    this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/region', {country: this.countryControl.value}, this.userInfos['access_token']).subscribe((data:any)=>{
      this.regions = data;
      this.filteredRegions = this.regions;
    });
  }
  updateInstitution(){
    let data = {cycle: this.cycleControl.value, region: this.regionControl.value};
    this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/institution', data, this.userInfos['access_token']).subscribe((data:any)=>{
      this.institutions = data;
      this.filteredInstitutions = this.institutions;
    });
  }
  updateClass(){
    let data = {
      country: this.countryControl.value,
      cycle: this.cycleControl.value
    }
    this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/class', data, this.userInfos['access_token']).subscribe((data:any)=>{
      this.classes = data;
      this.filteredClasses = this.classes;
    });
  }
  updateStudy(){
    let data = {
      country: this.countryControl.value,
      cycle: this.cycleControl.value,
      class: this.classControl.value
    }
    this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/study', data, this.userInfos['access_token']).subscribe((data:any)=>{
      this.studies = data;
      this.filteredStudies = this.studies;
    });
  }
  updateModule(){
    let data = {
      country: this.countryControl.value,
      cycle: this.cycleControl.value,
      class: this.classControl.value,
      study: this.studyControl.value
    }
    this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/module', data, this.userInfos['access_token']).subscribe((data:any)=>{
      this.modules = data;
      this.filteredModules = this.modules;
    });
  }
  updateSubject(){
    if(this.typeControl.value == 2){
      let parentIds = [this.countryControl.value ?? 0, this.cycleControl.value ?? 0, this.regionControl.value ?? 0, 
        this.institutionControl.value ?? 0, this.studyControl.value ?? 0, this.classControl.value ?? 0, this.moduleControl.value ?? 0,
        this.yearControl.value ?? 0, this.periodControl.value ?? 0, this.sectionControl.value ?? 0];

      let data = {
        parent_ids: parentIds, 
        id_content: this.rowInfos['id_content'],
        id_project: this.source == 'project'? this.rowInfos['id_project']: null,
        source: this.source
      }
      this.apiService.queryData(config.master.ndapi.url + '/virtualclass/infos_child/subject', data, this.userInfos['access_token']).subscribe((data:any)=>{
        this.subjects = data;
        this.filteredSubjects = this.subjects;
        
      });
    }
    this.resetSubjects();
  }
  updateLearning(){
    if([5, 7].includes(this.sectionControl.value)){
      let data = {
        id_module: this.moduleControl.value,
        id_project: this.source == 'project'? this.rowInfos['id_project']: null,
        id_content: this.rowInfos['id_content'],
        source: this.source
      }
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/learning', data, this.userInfos['access_token']).subscribe((data:any)=>{
        this.learnings = data;
        this.filteredLearnings = this.learnings;
      });
    }
    this.resetSubjects();
  }
  resetSubjects(){
    this.showContentChapter = this.sectionControl.value == 4? true: false;
    this.showContentLearning = [5, 7].includes(this.sectionControl.value) && this.typeControl.value != 2? true: false;
    this.showContentSubject = this.typeControl.value == 2? true: false;
    this.cdRef.detectChanges();
  }
  switchEditRaw(){
    if(this.source == 'content'){
      this.pdfRawData['refresh'] = true;
      this.pdfEditData['refresh'] = true;
      this.pdfRawData =  {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCLASS/'+this.rowInfos['raw_file_path']}], source: 'service', height: 320};
      this.pdfEditData = {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCLASS/'+this.rowInfos['edit_file_pdf']}], source: 'service', height: 320};
    }
    this.pdfMode = this.pdfMode == 'raw'? 'edit': 'raw';
  }
  lunchAnswerEdition(){
    const dialogRef = this.dialog.open(MarkdownEditorComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {row_infos: this.rowInfos, user_infos: this.userInfos, platform_infos: this.platformInfos, source: this.source}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  lunchEdition(){
    const dialogRef = this.dialog.open(ProjectEditingComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {project: {last_task: 'task-editing'}, content_data: [this.rowInfos], user_infos: this.userInfos, platform_infos: this.platformInfos, source: this.source}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}